
import { Component, Vue } from 'vue-property-decorator'
import SButton from '@/components/SButton.vue'
import STextField from '@/components/STextField.vue'
import { addressValidation } from '@/plugins/popups'
import { AddressesStore } from '@/store/stores/AddressesStore'
import { AddressModel } from '@/store/models/AddressModel'

@Component({
  components: { STextField, SButton },
})
export default class Addresses extends Vue {
  mode = ''
  isEmptyAddress = false
  disableAddressBtn = false
  address: AddressModel = AddressModel.getInstance()
  addresses: AddressesStore = AddressesStore.getInstance()

  openModal() {
    this.isEmptyAddress = false
    this.$modal.show('addressModal')
  }

  closeModal() {
    this.$modal.hide('addressModal')
  }

  beforeClose() {
    setTimeout(() => {
      this.addresses.loadData()
    }, 1000)
  }

  deleteAddress(id: number) {
    this.address.deleteAddress(id, () => {
      setTimeout(() => {
        this.addresses.loadData()
      }, 500)
    })
  }

  openCreateAddressModal() {
    this.mode = 'Create'
    this.openModal()
    this.address.address = ''
    this.address.city = 'Tiranë'
    this.address.zipCode = ''
    this.address.isDefault = false
  }

  createAddress() {
    if (!this.address.address) {
      this.isEmptyAddress = true
      return
    }

    if (this.address.address.length < 5) {
      addressValidation()
      return
    }

    let payload: any = {
      country: 'Albania',
      city: 'Tiranë',
      zip_code: this.address.zipCode,
      is_default: this.address.isDefault,
      ...this.address,
    }
    this.address.createAddress(payload)
    this.addresses.loadData()
    this.closeModal()
  }

  openEditAddressModal(address: any) {
    this.mode = 'Edit'
    this.address.factory(address)
    this.openModal()
  }

  editAddress() {
    if (!this.address.address) {
      this.isEmptyAddress = true
      return
    }

    if (this.address.address.length < 5) {
      addressValidation()
      return
    }

    const payload = {
      zip_code: this.address.zipCode,
      is_default: this.address.isDefault,
      ...this.address,
    }
    this.address.updateAddress(payload)
    this.addresses.loadData()
    this.closeModal()
  }

  changeAddressState(addressState: any) {
    addressState.isDefault = !addressState.isDefault
    const payload = {
      is_default: this.address.isDefault,
      ...this.address,
    }
    if (this.mode == 'Edit') {
      this.address.updateAddressStatus(payload)
    }

    this.addresses.loadData()
  }

  mounted() {
    this.addresses.loadData()
  }
}
